export type PronunciationGroupId = 'places' | 'food' | 'getting-around' | 'courtesy';

export interface PronunciationTerm {
  id: string;
  term: string;
  /** Shown under the term — English respelling for travelers. */
  phonetic: string;
  /** Spoken by Web Speech (English voice) — no navigation, no new window. */
  say: string;
  meaning: string;
  group: PronunciationGroupId;
}

export const PRONUNCIATION_GROUPS: { id: PronunciationGroupId; label: string }[] = [
  { id: 'places', label: 'Places' },
  { id: 'food', label: 'Food & drink' },
  { id: 'getting-around', label: 'Getting around' },
  { id: 'courtesy', label: 'Courtesy' },
];

export const PRONUNCIATION_TERMS: PronunciationTerm[] = [
  {
    id: 'carvoeiro',
    term: 'Carvoeiro',
    phonetic: 'kar-voo-AY-roo',
    say: 'kar voo AY roo',
    meaning: 'This town',
    group: 'places',
  },
  {
    id: 'rocha-brava',
    term: 'Rocha Brava',
    phonetic: 'RO-sha BRAH-va',
    say: 'RO sha BRAH vah',
    meaning: 'Home resort',
    group: 'places',
  },
  {
    id: 'alfanzina',
    term: 'Alfanzina',
    phonetic: 'al-fan-ZEE-na',
    say: 'al fan ZEE nah',
    meaning: 'Lighthouse neighborhood',
    group: 'places',
  },
  {
    id: 'algar-seco',
    term: 'Algar Seco',
    phonetic: 'al-GAR SEH-koo',
    say: 'al GAR SEH koo',
    meaning: 'Boardwalk and rock stacks',
    group: 'places',
  },
  {
    id: 'benagil',
    term: 'Benagil',
    phonetic: 'ben-ah-ZHEEL',
    say: 'ben ah ZHEEL',
    meaning: 'Sea cave — go by boat',
    group: 'places',
  },
  {
    id: 'lagoa',
    term: 'Lagoa',
    phonetic: 'la-GO-ah',
    say: 'la GO ah',
    meaning: 'Municipality and market town',
    group: 'places',
  },
  {
    id: 'portimao',
    term: 'Portimão',
    phonetic: 'por-tee-MOWNG',
    say: 'por tee MOWNG',
    meaning: 'Hospital and shopping',
    group: 'places',
  },
  {
    id: 'faro',
    term: 'Faro',
    phonetic: 'FAH-roo',
    say: 'FAH roo',
    meaning: 'Airport (FAO)',
    group: 'places',
  },
  {
    id: 'pastel-de-nata',
    term: 'Pastel de nata',
    phonetic: 'pash-TEL de NAH-ta',
    say: 'pash TEL de NAH tah',
    meaning: 'Custard tart',
    group: 'food',
  },
  {
    id: 'cataplana',
    term: 'Cataplana',
    phonetic: 'kah-tah-PLAH-na',
    say: 'kah tah PLAH nah',
    meaning: 'Copper-pan seafood',
    group: 'food',
  },
  {
    id: 'bacalhau',
    term: 'Bacalhau',
    phonetic: 'bah-kah-LYOW',
    say: 'bah kah LYOW',
    meaning: 'Salt cod',
    group: 'food',
  },
  {
    id: 'ameijoas',
    term: 'Ameijoas',
    phonetic: 'ah-MAY-zhwash',
    say: 'ah MAY zhwash',
    meaning: 'Clams',
    group: 'food',
  },
  {
    id: 'piri-piri',
    term: 'Piri-piri',
    phonetic: 'peer-ee PEER-ee',
    say: 'peer ee PEER ee',
    meaning: 'Hot chili',
    group: 'food',
  },
  {
    id: 'cerveja',
    term: 'Cerveja',
    phonetic: 'ser-VAY-zha',
    say: 'ser VAY zha',
    meaning: 'Beer',
    group: 'food',
  },
  {
    id: 'praia',
    term: 'Praia',
    phonetic: 'PRY-ah',
    say: 'PRY ah',
    meaning: 'Beach',
    group: 'getting-around',
  },
  {
    id: 'autocarro',
    term: 'Autocarro',
    phonetic: 'ow-toh-KAH-roo',
    say: 'ow toh KAH roo',
    meaning: 'Bus',
    group: 'getting-around',
  },
  {
    id: 'farmacia',
    term: 'Farmácia',
    phonetic: 'far-MAH-see-ah',
    say: 'far MAH see ah',
    meaning: 'Pharmacy',
    group: 'getting-around',
  },
  {
    id: 'aeroporto',
    term: 'Aeroporto',
    phonetic: 'ah-eh-roh-POR-too',
    say: 'ah eh roh POR too',
    meaning: 'Airport',
    group: 'getting-around',
  },
  {
    id: 'obrigado',
    term: 'Obrigado',
    phonetic: 'oh-bree-GAH-doo',
    say: 'oh bree GAH doo',
    meaning: 'Thank you (said by a man)',
    group: 'courtesy',
  },
  {
    id: 'obrigada',
    term: 'Obrigada',
    phonetic: 'oh-bree-GAH-da',
    say: 'oh bree GAH dah',
    meaning: 'Thank you (said by a woman)',
    group: 'courtesy',
  },
  {
    id: 'por-favor',
    term: 'Por favor',
    phonetic: 'poor fah-VOR',
    say: 'poor fah VOR',
    meaning: 'Please',
    group: 'courtesy',
  },
  {
    id: 'bom-dia',
    term: 'Bom dia',
    phonetic: 'bon DEE-ah',
    say: 'bon DEE ah',
    meaning: 'Good morning',
    group: 'courtesy',
  },
  {
    id: 'quanto-custa',
    term: 'Quanto custa?',
    phonetic: 'KWAN-too KOOSH-ta',
    say: 'KWAN too KOOSH tah',
    meaning: 'How much?',
    group: 'courtesy',
  },
  {
    id: 'fala-ingles',
    term: 'Fala inglês?',
    phonetic: 'FAH-la een-GLAYSH',
    say: 'FAH la een GLAYSH',
    meaning: 'Do you speak English?',
    group: 'courtesy',
  },
];
